"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

export const ContainerComponent: RegisteredComponent = {
  name: "Container",
  component: dynamic(() => import("./Container").then((mod) => mod.Container)),
  canHaveChildren: true,
};
